export default __webpack_public_path__ + "static/media/edit-disable.7cd02015.svg";